import { render, staticRenderFns } from "./updateCoach.vue?vue&type=template&id=0aadff53&"
import script from "./updateCoach.vue?vue&type=script&lang=js&"
export * from "./updateCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aadff53')) {
      api.createRecord('0aadff53', component.options)
    } else {
      api.reload('0aadff53', component.options)
    }
    module.hot.accept("./updateCoach.vue?vue&type=template&id=0aadff53&", function () {
      api.rerender('0aadff53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/eventmanagement/coachmanage/component/updateCoach.vue"
export default component.exports